import LocationFormInModal from './LocationFormInModal'

export default LocationFormInModal
